import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const SKELETON_ROWS = 8;

const initialsOf = (value = "") =>
  value
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join("");

// Image + text cell with an initials fallback (live rows carry profilePic /
// companyLogo URLs; mock rows have none and render initials).
const MediaCell = ({ text, imageUrl, round }) => (
  <span className="copilotTable__mediaCell">
    {imageUrl ? (
      <img
        src={imageUrl}
        alt=""
        className={`copilotTable__media ${round ? "round" : ""}`}
        loading="lazy"
        onError={event => {
          event.target.classList.add("hidden");
          if (event.target.nextSibling) {
            event.target.nextSibling.classList.remove("hidden");
          }
        }}
      />
    ) : null}
    <span
      className={`copilotTable__mediaFallback ${round ? "round" : ""} ${
        imageUrl ? "hidden" : ""
      }`}
    >
      {initialsOf(text)}
    </span>
    <span className="copilotTable__mediaText" title={text}>
      {text}
    </span>
  </span>
);

const ProspectTable = observer(({ table, tableId }) => {
  const columns = table.columns || [];
  const showRemove = copilotStore.supportsRowRemove;

  if (table.loading) {
    return (
      <div className="copilotTable">
        {Array.from({ length: SKELETON_ROWS }, (value, index) => (
          <div
            className="copilotTable__skeletonRow linear-background"
            key={`skeleton_${index}`}
          />
        ))}
      </div>
    );
  }

  if (!table.rows.length) {
    return (
      <div className="copilotTable__empty">
        <i className="material-icons-outlined">grid_on</i>
        <span>No records on this page.</span>
      </div>
    );
  }

  return (
    <table className="copilotTable">
      <thead>
        <tr>
          {columns.map(column => (
            <th key={column.key}>{column.label}</th>
          ))}
          {showRemove && <th className="copilotTable__actionsHead" />}
        </tr>
      </thead>
      <tbody>
        {table.rows.map(row => (
          <tr key={row.id}>
            {columns.map(column => (
              <td key={column.key} title={column.type ? undefined : row[column.key]}>
                {column.type === "avatar" || column.type === "logo" ? (
                  <MediaCell
                    text={row[column.key]}
                    imageUrl={column.imageKey ? row[column.imageKey] : ""}
                    round={column.type === "avatar"}
                  />
                ) : (
                  row[column.key]
                )}
              </td>
            ))}
            {showRemove && (
              <td className="copilotTable__actions">
                <span
                  className="material-icons-outlined copilotTable__removeIcon"
                  title="Remove from list"
                  onClick={() => copilotStore.removeTableRow(tableId, row.id)}
                >
                  delete
                </span>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
});

export default ProspectTable;
